// Intestazione: logo (o nome) dell'installatore "in collaborazione con" TORRI
export function BrandBar({ logo, nome, compact, clienteLogo, clienteLogoBg, big }) {
  const hLogo = big ? "h-[3.3rem]" : "h-11", hTorri = big ? "h-[3.3rem]" : "h-7", hColl = big ? "h-[3.3rem]" : "h-8";
  const tNome = big ? "text-[1.65rem]" : "text-sm", hDiv = big ? "h-[3.3rem]" : "h-9";
  const hCliente = big ? "h-[4.4rem]" : "h-14";
  if (clienteLogo) {
    // Vista Pro: logo del CLIENTE in primo piano; "in collaborazione con" mostra il logo dell'INSTALLATORE
    // (o TORRI se l'impianto è seguito direttamente da Torri / l'installatore non ha un logo).
    const diretto = !logo || /divisione impianti torri/i.test(nome || "");
    // Su header scuro (big) ogni logo ha sfondo garantito: chip bianco di default, così nessun logo chiaro o scuro sparisce.
    const cliBg = clienteLogoBg || (big ? "#ffffff" : undefined);
    return (
      <div className={`flex items-center justify-between gap-3 ${compact ? "" : "rounded-3xl bg-white px-4 py-3 shadow-sm ring-1 ring-slate-100"}`} data-testid="cliente-brand">
        <div className="flex min-w-0 flex-1 items-center">
          <span className="inline-flex items-center justify-center overflow-hidden rounded-xl px-2 py-1" style={cliBg ? { backgroundColor: cliBg } : undefined}>
            <img src={clienteLogo} alt={nome || "Cliente"} className={`${hCliente} max-w-full object-contain`} data-testid="cliente-brand-logo" />
          </span>
        </div>
        <span className={`${hDiv} w-px shrink-0 bg-slate-200`} />
        {diretto
          ? <img src={big ? "/torri-logo-full-dark.png" : "/torri-logo.png"} alt="TORRI" className={`${hTorri} shrink-0 object-contain`} data-testid="cliente-brand-torri" />
          : big
            ? <span className="inline-flex shrink-0 items-center justify-center rounded-xl bg-white px-2.5 py-1.5"><img src={logo} alt={nome || "Installatore"} className={`${hColl} max-w-[170px] object-contain`} data-testid="cliente-brand-collaboratore" /></span>
            : <img src={logo} alt={nome || "Installatore"} className={`${hColl} max-w-[170px] shrink-0 object-contain`} data-testid="cliente-brand-collaboratore" />}
      </div>
    );
  }
  if (/divisione impianti torri/i.test(nome || "")) return (
    // impianti seguiti direttamente da TORRI: nella Vista Schermo (big) mostriamo solo la scritta, senza logo
    <div className={`flex items-center justify-between gap-3 ${compact ? "rounded-2xl" : "rounded-3xl"} ${big ? "" : "bg-black px-4 py-3 shadow-sm"}`} data-testid="cliente-brand">
      {!big && <img src="/torri-logo-full-dark.png?v=1" alt="TORRI Beyond Ordinary Solar" className="h-12 min-w-0 shrink object-contain object-left" data-testid="cliente-brand-torri" />}
      <span className={`shrink-0 ${big ? "text-[1.65rem]" : "text-right text-[10px]"} font-bold uppercase leading-tight tracking-wider text-white/80`} data-testid="cliente-brand-nome">{nome}</span>
    </div>
  );
  return (
    <div className={`flex items-center justify-between gap-3 ${compact ? "" : "rounded-3xl bg-white px-4 py-3 shadow-sm ring-1 ring-slate-100"}`} data-testid="cliente-brand">
      <div className="flex min-w-0 flex-1 items-center">
        {logo ? <img src={logo} alt={nome || "Installatore"} className={`${hLogo} max-w-full object-contain object-left`} data-testid="cliente-brand-logo" />
          : <b className={`line-clamp-2 ${tNome} font-extrabold leading-tight text-slate-800`} data-testid="cliente-brand-nome">{nome}</b>}
      </div>
      <span className={`${hDiv} w-px shrink-0 bg-slate-200`} />
      <img src="/torri-logo.png" alt="TORRI" className={`${hTorri} shrink-0 object-contain`} data-testid="cliente-brand-torri" />
    </div>
  );
}
